module.exports = __webpack_public_path__ + "746316d4aebb327964b5d90c8e3787ab.svg";